import { post, get } from "@/utils/request";

import axios from "axios";
const TARGET_SERVER = process.env.VUE_ENV === "server";
const baseUrl = process.env.config.RRDH_HOST;

export default {
  getList: query => post(baseUrl + "/rrbi/userInfo/getList", query),
  selectUID: id => get(baseUrl + "/rrbi/userInfo/userInfo-one?userId=" + id),
  select: id => post(baseUrl + "/rrbi/userInfo/userInfo/" + id),
  update: query => post(baseUrl + "/rrbi/userInfo/userInfo-update", query),
  getAtUserList: query => post(baseUrl + "/rrbi/userInfo/getAtUserList", query),
  getPage: query => post("/rrbi/userInfo/getPage", query),
  subtractTimes: query => post(baseUrl + "/rrbi/userInfo/subtractTimes", query),
  selectByInvitationCode:query => post(baseUrl + "/rrbi/userInfo/selectByInvitationCode", query),
};

//服务器渲染  数据获取
export function fetchUserDetail({ id, cookies }) {
  return axios.post(baseUrl + `/rrbi/userInfo/userInfo/${id}`, {
    headers: getCommonHeader({ cookies })
  });
}

export function fetchDaVList({ cookies }) {
  return axios.post(baseUrl + `/rrbi/userInfo/getList`, {
    headers: getCommonHeader({ cookies })
  });
}
function getCommonHeader({ cookies }) {
  if (TARGET_SERVER && cookies) {
    return { cookie: getCookieString(cookies) };
  } else {
    return null;
  }
}

function getCookieString(cookies) {
  let cookieStr = "";
  for (var variable in cookies) {
    if (Object.prototype.hasOwnProperty.call(cookies, "variable")) {
      cookieStr += `${variable}=${encodeURIComponent(cookies[variable])}; `;
    }
  }
  return cookieStr;
}
